import axios from "../axios-auth";
import orginal_axios from "axios";

export const assetService = {
    getAssetList,
    getAssetDetail,
    saveAsset,
    calculateAssetDetail,
    getAssetExcelExport,
    getAllAssetist,
    getAssetExcelTemplate,
    saveAssetExcel
};

function getAssetList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.statusList) {
        params["statusList"] = searchParams.statusList.join();
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.shopCode) {
        params["shopCode"] = searchParams.shopCode;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.assetName) {
        params["assetName"] = searchParams.assetName;
    }
    if (searchParams.assetType) {
        params["assetType"] = searchParams.assetType;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (searchParams.branchId) {
        params["branchId"] = searchParams.branchId;
    }

    return axios.get("/auth/assets", { params });
}

function getAssetDetail(id) {
    return axios.get("/auth/asset/" + id);
}

function saveAsset(asset) {
    if (!asset.id) {
        // new 
        return axios.post("/auth/asset", asset);
    } else {
        // edit
        return axios.put("/auth/asset", asset);
    }
}

function calculateAssetDetail(depreciation) {
    return axios.post("/auth/calculate-detail", depreciation);
}

function getAssetExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.shopCode) {
        params["shopCode"] = searchParams.shopCode;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.assetType) {
        params["assetType"] = searchParams.assetType;
    }
    if (searchParams.assetName) {
        params["assetName"] = searchParams.assetName;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (searchParams.branchId) {
        params["branchId"] = searchParams.branchId;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/asset-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getAllAssetist(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.code) {
        params["code"] = searchParams.code;
    }
    if (searchParams.shopCode) {
        params["shopCode"] = searchParams.shopCode;
    }
    if (searchParams.accountName) {
        params["accountName"] = searchParams.accountName;
    }
    if (searchParams.assetType) {
        params["assetType"] = searchParams.assetType;
    }
    if (searchParams.assetName) {
        params["assetName"] = searchParams.assetName;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (searchParams.branchId) {
        params["branchId"] = searchParams.branchId;
    }

    return axios.get("/auth/assets", { params });
}

function getAssetExcelTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/asset-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function saveAssetExcel(file) {
    return axios.post('/auth/asset-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}